module.exports = __webpack_public_path__ + "img/utility-fcae.fe5b2c14.png";